import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=353ea74a&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"
import style0 from "./CookieBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports